@let linkValue = link();

@if (linkValue) {
  @if (externalLink() && linkValue.length > 0) {
    <a
      [href]="linkValue[0]"
      target="_blank"
      rel="noopener noreferrer"
      class="more-menu-item"
    >
      <ng-container *ngTemplateOutlet="content" />
    </a>
  } @else {
    <a
      [routerLink]="linkValue"
      class="more-menu-item"
      routerLinkActive="more-menu-item-active"
    >
      <ng-container *ngTemplateOutlet="content" />
    </a>
  }
} @else {
  <span class="more-menu-item">
    <ng-container *ngTemplateOutlet="content" />
  </span>
}

<ng-template #content>
  <ng-content />
  <fa-icon [icon]="faChevronRight" />
</ng-template>
